// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___1Ytft","input":"input___OMsAE","icon":"icon___2ZM73"};